import axios from "axios";
import { useMutation, useQueryClient } from "react-query";
import { config } from "../../utils/conf";
import { requestHeaders } from "../../utils/http";
import useSession from "../Auth/useSession";

export default function useUpdateRecipient(options = {}) {
  const { accessToken } = useSession();
  const cache = useQueryClient();

  const mutation = useMutation(
    async ({ recipientId, payload }) => {
      if (!recipientId) throw new Error("recipientId is required");

      return axios.put(
        `${config.customerProfileApiUrl}/v1/recipients/${recipientId}`,
        payload,
        {
          headers: {
            ...requestHeaders(accessToken),
            "Content-Type": "application/json",
          },
        },
      );
    },
    {
      onSuccess: () => {
        cache.invalidateQueries("notification-recipients");
      },
      ...options,
    },
  );

  return {
    updateRecipient: mutation.mutateAsync,
    updateRecipientStatus: mutation,
  };
}
